import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=10840a98&scoped=true"
import script from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=10840a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10840a98",
  null
  
)

export default component.exports